import { render, staticRenderFns } from "./BaseView.vue?vue&type=template&id=2ac92bfe&"
import script from "./BaseView.vue?vue&type=script&lang=ts&"
export * from "./BaseView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports